import { useCallback, useContext, useEffect, useState } from "react";
import {
  filterCompletedJobStatuses,
  publishCompletedCompilationJobStatuses,
  publishExpiredCompilationJobStatuses,
  removeCompletedAndExpiredCompilationJobs,
} from "./useJobsDownloadNotifierHelpers";
import { ConfigContext } from "../../context/ConfigContext";
import { DOWNLOAD_NEW_JOB_ADDED } from "../../utils/eventConstants";
import {
  getPendingDownloadJobs,
  PendingCompilationJob,
} from "../../utils/notificationsUtils";
import useJobsDownloadStatus from "../useJobsDownloadStatus/useJobsDownloadStatus";

const useJobsDownloadNotifier = (accountId: string) => {
  const [pendingJobs, setPendingJobs] = useState<PendingCompilationJob[]>([]);
  const { downloadStatuses } = useJobsDownloadStatus(
    accountId,
    pendingJobs.map((job) => job.jobId)
  );
  const { PROMOTION_DOWNLOAD_JOB_TIMEOUT = 15000 } = useContext(ConfigContext);

  const handler = useCallback(() => {
    const pendingDownloadJobs = getPendingDownloadJobs(accountId);
    setPendingJobs(pendingDownloadJobs);
  }, [accountId]);

  useEffect(() => {
    window.addEventListener(DOWNLOAD_NEW_JOB_ADDED, handler);
    return () => window.removeEventListener(DOWNLOAD_NEW_JOB_ADDED, handler);
  }, [accountId]);

  useEffect(() => {
    const completedJobStatuses = filterCompletedJobStatuses(downloadStatuses);
    const { remainingJobs, expiredJobs } =
      removeCompletedAndExpiredCompilationJobs(
        accountId,
        completedJobStatuses,
        PROMOTION_DOWNLOAD_JOB_TIMEOUT
      );
    publishCompletedCompilationJobStatuses(completedJobStatuses, pendingJobs);
    publishExpiredCompilationJobStatuses(expiredJobs);
    setPendingJobs([...remainingJobs]);
  }, [downloadStatuses, accountId]);
};

export default useJobsDownloadNotifier;
